import type { Maybe } from '@adornis/base/utilTypes.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { ChromiumDialog } from '@chancenwerk/client/design/components/cr-dialog.js';
import { Product } from '@chancenwerk/shared/_cms/products/entities/Product.js';
import { KPF } from '@chancenwerk/shared/master-data-management/kpf/entities/KPF.js';
import { School } from '@chancenwerk/shared/master-data-management/partner/entities/School.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

const kpfSelector: BaseQLSelectionSet<KPF> = {
  _id: 1,
  _class: 1,
  kuerzel: 1,
  school: {
    name: 1,
  },
  produkt: Product.allFields,
};

@customElement('board-dialog-add-kpf')
export class BoardDialogAddKPF extends ChromiumDialog<string> {
  @property({ attribute: false }) public filterKpfs: string[] = [];

  @state() private readonly _kpfs = new RXController(this, KPF.subscribeAll<KPF>()(kpfSelector));

  @state() private readonly _selectedKpf = new RXController<KPF | null>(this, null);

  static override get element_name() {
    return 'board-dialog-add-kpf';
  }

  override heading = 'KPF hinzufügen';

  override content() {
    return html`
      <cr-flex space="md" ${css({ width: '450px' })}>
        <cr-dropdown-search-selection
          ${css({ margin: '0 0 20px 0' })}
          clearable
          .value=${this._selectedKpf.value}
          ?flex=${!this._selectedKpf.value}
          icon="search"
          placeholder="KPF"
          .renderString=${(entry: Maybe<KPF>) => {
            if (!entry) return '';
            return entry.stringRepresentation;
          }}
          .search=${(search: string) => {
            return this._kpfs.value?.filter(
              kpf =>
                kpf.school?.name?.toLowerCase().includes(search.toLowerCase()) ||
                kpf.kuerzel.toLowerCase().includes(search.toLowerCase()),
            );
          }}
          @value-picked=${(e: CustomEvent<{ value: KPF }>) => {
            this._selectedKpf.next(e.detail.value);
          }}
        ></cr-dropdown-search-selection>
        <cr-button icon="add" @click=${() => this.close(this._selectedKpf.value?._id ?? '')}>Hinzufügen</cr-button>
      </cr-flex>
    `;
  }
}
